angular.module('bizmetryApp').controller('PlatformContentCtrl', ['$scope', '$mdDialog', function ($scope, $mdDialog) {
  $scope.features = [
    {
      image: '/assets/platform/features/kpi.png',
      title: 'Custom KPIs',
      desc: 'Define business metrics without relying on engineering teams.'
    },
    {
      image: '/assets/platform/features/dashboard.png',
      title: 'Real-Time Dashboards',
      desc: 'Visualize metrics and connected agents live.'
    },
    {
      image: '/assets/platform/features/ai-monitoring.png',
      title: 'AI Monitoring',
      desc: 'Track precision, consistency and completeness of AI responses.'
    },
    {
      image: '/assets/platform/features/integration.png',
      title: 'Seamless Integration',
      desc: 'Connect any system through our open agent.'
    },
    {
      image: '/assets/platform/features/asbo.png',
      title: 'Structured ASBO Definitions',
      desc: 'Define business entities, attributes and types with structured logic.'
    },
    {
      image: '/assets/platform/features/metadata-import.png',
      title: 'Metadata Import from Databases',
      desc: 'Import schema metadata and generate entities directly from your data sources.'
    },
    {
      image: '/assets/platform/features/templates.png',
      title: 'Template Inheritance',
      desc: 'Create business-specific templates derived from master telemetry templates.'
    },
    {
      image: '/assets/platform/features/reports.png',
      title: 'Dashboards and Reports',
      desc: 'Generate real-time dashboards and export custom analytics reports.'
    },
    {
      image: '/assets/platform/features/agent-management.png',
      title: 'Central Agent Management',
      desc: 'Deploy, monitor and control telemetry agents across all environments from a unified interface.'
    }
  ];

  // ── Screenshots — 21 items from assets/screens/, grouped by domain ──────────
  // 21 items / 3 columns = 7 clean rows (see .bm-screenshots__grid in landing.css)
  $scope.screenshots = [

    // Dashboard & Home
    { url: '/assets/platform/screens/home.png',
      caption: 'Main Dashboard — View your Telemetry profiles at a glance' },

    // Auth
    { url: '/assets/platform/screens/federated-login.png',
      caption: 'Federated Login - Access your BizMetry® account' },

    // Agents
    { url: '/assets/platform/screens/agents-summary.png',
      caption: 'Agents Summary — Fleet health and telemetry status' },
    { url: '/assets/platform/screens/agent-panel.png',
      caption: 'Agent Panel — Manage and monitor distributed agents' },
    { url: '/assets/platform/screens/agent-configuration.png',
      caption: 'Agent Configuration — Declare and deploy biz telemetry agents' },
    { url: '/assets/platform/screens/agent-monitoring.png',
      caption: 'Agent Monitoring — Real-time performance metrics' },

    // Templates & BMEL
    { url: '/assets/platform/screens/template-explorer.png',
      caption: 'Template Explorer — Browse and manage telemetry templates' },
    { url: '/assets/platform/screens/template-editor.png',
      caption: 'Template Editor — Edit the telemetry template' },
    { url: '/assets/platform/screens/bmel-editor.png',
      caption: 'BMEL — BizMetry® expression language' },

    // Business Events
    { url: '/assets/platform/screens/business-event-composer.png',
      caption: 'Business Event Composer — Create and configure BizEvents' },

    // Data & Resources
    { url: '/assets/platform/screens/data-explorer-tool.png',
      caption: 'Data Explorer — Query your on-premise data to look for ASBOs' },
    { url: '/assets/platform/screens/table-mapper.png',
      caption: 'Table Mapper — Drag-and-drop field mapping interface' },
    { url: '/assets/platform/screens/new-datasource.png',
      caption: 'New Datasource — Connect and configure data sources' },
    { url: '/assets/platform/screens/import-resources.png',
      caption: 'Import Resources — Import resources from your own on-premise data' },
    { url: '/assets/platform/screens/import-resource-types.png',
      caption: 'Resource Types — Import ASBOs from your own data' },

    // Profiles
    { url: '/assets/platform/screens/profile-creation-wizard.png',
      caption: 'Profile Creation Wizard' },
    { url: '/assets/platform/screens/profile-details.png',
      caption: 'Profile Details — Configure your Telemetry profile' },
    { url: '/assets/platform/screens/profile-tree.png',
      caption: 'Profile Tree — Hierarchical view of telemetry templates' },

    // Infrastructure
    { url: '/assets/platform/screens/environments.png',
      caption: 'Environments — Deploy templates across environments' },

    // Jobs
    { url: '/assets/platform/screens/job-execution-histogram.png',
      caption: 'Job Execution Histogram — Access your system-wide job details' },
    { url: '/assets/platform/screens/job-summary.png',
      caption: 'Job Summary — Execution history and status tracking' }

  ];


  $scope.showScreenshotFullsize = function (screenshot, event) {
    if (event) { event.preventDefault(); }
    $mdDialog.show({
      controller: ['$scope', '$mdDialog', 'screenshot', function ($scope, $mdDialog, screenshot) {
        $scope.screenshot = screenshot;
        $scope.close = function () { $mdDialog.hide(); };
      }],
      template: '<md-dialog class="bm-platform-preview" aria-label="Platform screenshot"><md-toolbar><div class="md-toolbar-tools"><h2>{{ screenshot.caption }}</h2><span flex></span><md-button class="md-icon-button" aria-label="Close screenshot" ng-click="close()"><span class="material-icons">close</span></md-button></div></md-toolbar><md-dialog-content><img ng-src="{{ screenshot.url }}" alt="{{ screenshot.caption }}" /></md-dialog-content></md-dialog>',
      locals: { screenshot: screenshot },
      targetEvent: event,
      clickOutsideToClose: true,
      escapeToClose: true
    });
  };
}]);
